var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMenuHilights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_menu",
    transform: "translate(-0.488 0.033)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1123",
    "data-name": "Rectangle 1123",
    width: 24,
    height: 24,
    transform: "translate(0.488 -0.033)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_14",
    "data-name": "Union 14",
    d: "M-8199.15-1560.326l-.243-1.138a4.8,4.8,0,0,1-1.225-.711l-1.106.363a.58.58,0,0,1-.688-.256l-.981-1.7a.582.582,0,0,1,.116-.721l.865-.779a5.133,5.133,0,0,1-.054-.713,4.587,4.587,0,0,1,.054-.711l-.87-.771a.585.585,0,0,1-.115-.721l.975-1.7a.59.59,0,0,1,.687-.264l1.113.363a4.714,4.714,0,0,1,1.225-.709l.236-1.138a.579.579,0,0,1,.569-.462h1.954a.586.586,0,0,1,.572.462l.237,1.134a4.746,4.746,0,0,1,1.229.713l1.113-.365a.583.583,0,0,1,.682.262l.983,1.688a.584.584,0,0,1-.115.725l-.868.783a4.359,4.359,0,0,1,.054.711,4.845,4.845,0,0,1-.05.713l.868.767a.583.583,0,0,1,.113.725l-.977,1.692a.575.575,0,0,1-.685.264l-1.111-.359a4.863,4.863,0,0,1-1.224.709l-.237,1.138a.584.584,0,0,1-.568.462l-1.961,0A.576.576,0,0,1-8199.15-1560.326Zm-.948-2.933a3.653,3.653,0,0,0,1.381.8.582.582,0,0,1,.4.435l.21,1h1.016l.206-1a.585.585,0,0,1,.4-.435,3.635,3.635,0,0,0,1.377-.806.577.577,0,0,1,.572-.122l.976.313.5-.878-.759-.68a.566.566,0,0,1-.184-.557,3.626,3.626,0,0,0,.091-.8,4.136,4.136,0,0,0-.091-.8.574.574,0,0,1,.18-.558l.758-.68-.507-.878-.973.322a.587.587,0,0,1-.575-.126,3.688,3.688,0,0,0-1.381-.8.583.583,0,0,1-.4-.433l-.211-1h-1.016l-.2,1a.6.6,0,0,1-.4.437,3.616,3.616,0,0,0-1.379.8.578.578,0,0,1-.573.126l-.969-.317-.5.878.761.68a.581.581,0,0,1,.179.557,3.511,3.511,0,0,0-.086.8,3.751,3.751,0,0,0,.086.8.574.574,0,0,1-.179.557l-.757.684.51.874.973-.317a.48.48,0,0,1,.179-.031A.592.592,0,0,1-8200.1-1563.259Zm2.478-.431h-.015a2.256,2.256,0,0,1-1.6-.668,2.274,2.274,0,0,1-.676-1.622,2.3,2.3,0,0,1,.672-1.624,2.289,2.289,0,0,1,1.622-.676.587.587,0,0,1,.581.585.58.58,0,0,1-.581.579,1.141,1.141,0,0,0-.8.334,1.124,1.124,0,0,0-.332.8,1.115,1.115,0,0,0,.332.8,1.13,1.13,0,0,0,.8.332,1.134,1.134,0,0,0,.8-.332,1.1,1.1,0,0,0,.33-.8.58.58,0,0,1,.579-.581.581.581,0,0,1,.583.581,2.257,2.257,0,0,1-.672,1.622,2.261,2.261,0,0,1-1.606.672Zm-14.892-.845v-1.5h6.969v.645l-.728.855Zm7.346-6h-7.346v-1.5h8.3l-.957,1.5Zm-7.346-6v-1.5h16v1.5Z",
    transform: "translate(8216 1582.999)",
    fill: "#15355c"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHilights);
export default __webpack_public_path__ + "static/media/menu_hilights.bc7412b4f61fc649df017fcd96fe49e0.svg";
export { ForwardRef as ReactComponent };